import * as React from 'react';

import './style.css';
import { makeFieldChangeHandle, makeValidateField, randomId } from './util';

export default function InputText({field, formControls=undefined, setFormControls=undefined, className=undefined, style=undefined, disabled=false, password=false}){
    let id = randomId();

    const [validity, setValidity] = React.useState({valid:true, warning:""})

    let handleFieldChange = undefined;
    if(formControls!=undefined){
        const validateField = (field.necessary?makeValidateField(field, setValidity):undefined);
        handleFieldChange = makeFieldChangeHandle(field, setFormControls, validateField)
    }
  
    return (
            <div hidden={field.hidden} className={"input-field "+(className!=undefined?className:"")} style={style}>
                <label htmlFor={id}>{field.label}</label>
                <input type={password?'password':'text'} disabled={field.disabled}  value={formControls!=undefined?formControls[field.name].value:""} onChange={handleFieldChange!=undefined?handleFieldChange:null} placeholder={field.placeholder!=undefined?field.placeholder:field.label} id={id}/>
                    {!formControls[field.name].validity.valid?<div className="warning">{formControls[field.name].validity.warning}</div>:<></>}
                </div>
    )
}
